import { lazy } from "react";

// Bespoke module screens, keyed by the module `key` set in Platform → Bespoke Modules.
// A key without an entry renders the "being built" placeholder in BespokeModulePage.
export const BESPOKE_REGISTRY = {
  "pops-waste-list": lazy(() => import("./PopsWasteList/PopsWasteListModule")),
};

export const bespokeComponent = (key) => BESPOKE_REGISTRY[key] || null;
